import { render, staticRenderFns } from "./extensions-upload.vue?vue&type=template&id=bc2c9af4"
import script from "./extensions-upload.vue?vue&type=script&lang=js"
export * from "./extensions-upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports